import { createFileRoute, Outlet } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

export const Route = createFileRoute('/$slug/processes/create-processes')({
  beforeLoad: createCaslGuard('Process', 'create'),
  component: Outlet
});
